export enum ProductType {
    Subscription = 'subscription',
    TimePackage = 'timePackage',
}

export enum OfferType {
    Subscription = 'subscription',
    TimePackage = 'timePackage',
    TrialSubscription = 'trialSubscription',
}
